import {
  HTTP_GETAPPROVE_FETCHING,
  HTTP_GETAPPROVE_SUCCESS,
  HTTP_GETAPPROVE_FAILED,
  server,
  OK,
  YES,
} from "././../../Constants";
import { httpClient } from "././../../utils/HttpClient";
import { async } from "q";
import Axios from "axios";

export const setStateApproveToFetching = () => ({
  type: HTTP_GETAPPROVE_FETCHING,
});

export const setStateApproveToSuccess = (payload) => ({
  type: HTTP_GETAPPROVE_SUCCESS,
  payload,
});

export const setStateApproveToFailed = (payload) => ({
  type: HTTP_GETAPPROVE_FAILED,
});

export const clearApprove = () => {
  return async (dispatch) => {
    dispatch(
      setStateApproveToSuccess({
        data: [],
      })
    );
  };
};

export const getApproveById = (year, memid, secureid, countryid, companyid) => {
  return async (dispatch) => {
    dispatch(setStateApproveToFetching());

    try {
      const result = await httpClient.get(
        `${server.GETAPPROVE_URL}/${year}/${memid}/${secureid}/${countryid}/${companyid}`
      );
      dispatch(
        setStateApproveToSuccess({
          data: result.data,
        })
      );
      return Promise.resolve(result.data);
    } catch (error) {
      // console.log("aaaaa");
      dispatch(setStateApproveToFailed());

      return Promise.reject(error.message);
    }
  };
};
